import { useState } from 'react'
import { message as $message } from 'antd'
import moment from 'moment'
import { saveDataByUid, getDataByUid } from '@/hooks/useRecordOperation/store'
import { queryRuleTipsResult, queryGoodsRuleOperateList, pageRuleLabel } from '@/services/goodsMonitoringRules'
const RULE_CHANGED_CACHE_KEY = 'GOODS_ANALYSIS_VIEW'

export default () => {
    const [goodsRuleTip, setGoodsRuleTip] = useState({}) // 商品运营分析提示
    const [goodsRuleList, setGoodsRuleList] = useState(null) // 商品运营分析规则
    const [goodsRuleLabelList, setGoodsRuleLabelList] = useState(null) // 商品运营分析规则

    const [ruleRecordTime, setRuleRecordTime] = useState(null)

    // 记录规则时间
    const recordRuleTime = () => {
        const timeStamp = Date.now()

        saveDataByUid(RULE_CHANGED_CACHE_KEY, timeStamp)
        setRuleRecordTime(timeStamp)
    }

    // 检测是否显示规则
    const checkShowRuleTip = () => {
        const cache = getDataByUid(RULE_CHANGED_CACHE_KEY)
        const time = typeof cache === 'string' && /^d+$/.test(cache) ? Number(cache) : cache

        const record = time ? moment(time).format('YYYY-MM-DD') : time

        if (!record) {
            return true
        }

        const now = moment(Date.now()).format('YYYY-MM-DD')

        return record !== now
    }

    const fetchGoodsRuleTip = async () => {
        try {
            const { success, data, message } = await queryRuleTipsResult()

            if (success) {
                setGoodsRuleTip(data)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    const fetchGoodsRuleList = async () => {
        try {
            const { success, data, message } = await queryGoodsRuleOperateList()

            if (success) {
                setGoodsRuleList(data || [])
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    const fetchGoodsRuleLabelList = async () => {
        try {
            const { success, data, message } = await pageRuleLabel({
                pageNum: 1,
                pageSize: 500 // 暂时写死，
            })

            if (success) {
                setGoodsRuleLabelList(data || [])
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    return {
        hasNewRuleData: goodsRuleTip?.hasNewRuleData,
        hasTips: goodsRuleTip?.hasNewRuleData, // 头部商品运营分析，显示有数据
        ruleDataNotUpdate: goodsRuleTip?.hasNewRuleData,
        ruleDataHasAddOrSubtract: goodsRuleTip?.ruleDataHasAddOrSubtract,
        goodsRuleList,
        goodsRuleLabelList,
        fetchGoodsRuleTip,
        fetchGoodsRuleList,
        fetchGoodsRuleLabelList,
        recordRuleTime,
        showRuleChangedTip: checkShowRuleTip(),
    }
}
